import React, {Component} from 'react';
import styles from './c_scenario_overview.css';
import dropdownIcon from '../../../assets/icons/icon_scenario_dropdown.svg';
import classNames from 'classnames';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

class ScenarioOverview extends Component {

  constructor(props){
    super(props)
    this.state = {
      dropdownActive: false
    }
  }

  handleDropdown = () =>{
    const dropdown = this.refs.dropdown;
    const activeState = this.state.dropdownActive;
    if (dropdown !== undefined){
      if(activeState){
        dropdown.classList.remove(styles.dropdownActive)
        this.setState({
          dropdownActive: false
        })
      }
      else{
        dropdown.classList.add(styles.dropdownActive)
        this.setState({
          dropdownActive: true
        })
      }
      
    }
  }

  // draggable(element) {
  //   var isMouseDown = false;
  //   var mouseX;
  //   var mouseY;
  //   var elementX = 0;
  //   var elementY = 0;
  //   var currentStyleX = 0;
  //   var originalStyleX = 0;

  //   element.addEventListener('mousedown', onMouseDown, false);

  //   /**
  //    * Listens to `mousedown` event.
  //    *
  //    * @param {Object} event - The event.
  //    */
  //   function onMouseDown(event) {
  //     mouseX = event.clientX;
  //     // mouseY = event.clientY;
  //     isMouseDown = true; 
  //     originalStyleX = parseInt(element.style.right, 10);
  //   }

  //   // mouse button released
  //   element.addEventListener('mouseup', onMouseUp);

  //   /**
  //    * Listens to `mouseup` event.
  //    *
  //    * @param {Object} event - The event.
  //    */ 
  //   function onMouseUp(event) {
  //     isMouseDown = false;
  //     elementX = parseFloat(element.style.left) || 0;
  //     if (parseFloat(currentStyleX) < -100) {
  //       element.classList.add('closed');
  //       element.style.right = '-180px';
  //       element.style.opacity = 0.5;
  //     } else {
  //       element.classList.remove('closed');
  //       element.style.right = '0';
  //       element.style.opacity = 1;
  //     }
  //   }

  //   // need to attach to the entire document
  //   // in order to take full width and height
  //   // this ensures the element keeps up with the mouse
  //   document.addEventListener('mousemove', onMouseMove);

  //   /**
  //    * Listens to `mousemove` event.
  //    *
  //    * @param {Object} event - The event.
  //    */
  //   function onMouseMove(event) {
  //     if (!isMouseDown) return;
  //       var deltaX = event.clientX - mouseX - originalStyleX;
  //       var deltaY = event.clientY - mouseY;
  //       element.style.right = elementX - deltaX + 'px';
  //       element.style.top = elementY - deltaY + 'px';
  //       currentStyleX = elementX - deltaX;

  //       if (elementX - deltaX > 0) {
  //         element.style.right = 0 + 'px';
  //         currentStyleX = 0;
  //       }
  //   }
  // }
  
  render() {
    const scenario = this.props.scenarioData
    const deviceData = this.props.deviceData
    const currency = this.props.currency

    const devices = deviceData.map( (item) => {
      const unitPriceString = `(${Number(item.unit_price).toLocaleString('de-DE')} ${currency.symbol})`
      return(
        <li key={item.id} value={item.id}>
          <span className={styles.leftRow}>
            {Lang.translate(`calculator:${item.localeName}`, this.props.location.pathname)}
            <span className={styles.price}>
              {unitPriceString}
            </span>
          </span>
          <span className={styles.qty}>
            {item.qty}
          </span>
        </li>
      );
    });

    // setTimeout(() => {
    //   // eslint-disable-next-line no-undef
    //   this.draggable(document.getElementById('sticky-menu'))
    // }, 1000)
    
    return (
      <aside id='sticky-menu' className={styles.overviewContainer} style={{ right: 0 }}>
        <h3>{scenario.capacity} {Lang.translate('calculator:pieceHour', this.props.location.pathname)}</h3>
        <div className={styles.scenarioName}>
          {scenario.name}
          <button onClick={this.handleDropdown}><img src={dropdownIcon} alt="" /></button>
        </div>
        <div className={classNames(styles.dropdown)} ref="dropdown">
          <span className={classNames(styles.headers, styles.headerLeft)}>{Lang.translate('calculator:device', this.props.location.pathname)}</span>
          <span className={classNames(styles.headers, styles.headerRight)}>{Lang.translate('calculator:qty', this.props.location.pathname)}</span>
          <ul>
            {devices}
          </ul>
          <button onClick={ (ev) => this.props.showOverlay(ev, true) } className={styles.button}>
            {Lang.translate('calculator:allSetups', this.props.location.pathname)}
          </button>
        </div>
      </aside>
    );
  }
}

export default withRouter(ScenarioOverview);



// WEBPACK FOOTER //
// ./src/components/calculator/totals/c_scenario_overview.js